export default __webpack_public_path__ + "static/media/learose2-1024w.c5d1aa5f.avif";